import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteExpenseReportRequestForm.ExpenseLines', {
    sectionName: 'Expenses',
    uploadErrorDuplicateName:
        'Please re-upload the file with a different name, as a file with "{fileName}" name is already added.',

    columnRefNo: 'Ref No.',
    columnRefNoPlaceholder: 'Enter Ref No.',
    columnDate: 'Date',
    columnDatePlaceholder: 'Select a date',
    columnCategory: 'Category',
    columnCategoryPlaceholder: 'Select category',
    columnExpenseAccount: 'Expense account',
    columnExpenseAccountPlaceholder: 'Select account',
    columnQuantity: 'Quantity',
    columnQuantityPlaceholder: 'Enter quantity',
    columnRate: 'Rate',
    columnRatePlaceholder: 'Enter rate',
    columnForeignAmount: 'Foreign Amount',
    columnForeignAmountPlaceholder: 'Enter foreign amount',
    columnCurrency: 'Currency',
    columnCurrencyPlaceholder: 'Enter currency',
    columnExchangeRate: 'Exchange Rate',
    columnExchangeRatePlaceholder: 'Enter exchange rate',
    columnAmount: 'Amount',
    columnAmountPlaceholder: 'Enter amount',
    columnTaxCode: 'Tax code',
    columnTaxCodePlaceholder: 'Select tax code',
    columnTaxRate: 'Tax rate',
    columnTaxAmount: 'Tax amount',
    columnTaxAmountPlaceholder: 'Enter tax amount',
    columnGrossAmount: 'Gross amount',
    columnGrossAmountPlaceholder: 'Enter gross amount',
    columnMemo: 'Memo',
    columnMemoPlaceholder: 'Enter memo',
    columnDepartment: 'Department',
    columnDepartmentPlaceholder: 'Select department',
    columnClass: 'Class',
    columnClassPlaceholder: 'Select class',
    columnLocation: 'Location',
    columnLocationPlaceholder: 'Select location',
    columnCustomer: 'Customer',
    columnCustomerPlaceholder: 'Select value',
    columnBillable: 'Billable',
    columnLineAttachment: 'Line Attachment',
    columnReceipt: 'Receipt',
    columnNonReimbursable: 'Non Reimbursable',
    columnCorporateCard: 'Corporate Card',
    selectDefaultPlaceholder: 'Select value',
    groupEdit: 'Edit selected',
    groupClone: 'Clone selected',
    groupRemove: 'Remove selected',
});
